import { fromJS, Map } from 'immutable'

export const HISTORY_ENTRY_COUNT = 20
export const CURRENT_PROJECT = (state) =>
  fromJS({
    project: Map(), ///state.getIn(['project']),
    pages: Map(), ///state.getIn(['pages'])
  })
export const HISTORY_PREV = ['history', 'prev']
export const HISTORY_NEXT = ['history', 'next']

export const disableHistory = (state) => state.set('disableDelta', true)
